import { ColumnDef, ModelDef } from '../../CORE/src/common/$models/ModelDef'
import { yhcAreaCodes, yhcAreasByCode } from '../constants/area'

const genSectionColumn = (
  section_name: string,
  inputComponent = undefined,
): ColumnDef => {
  return {
    type: 'STRING', // dummy
    hideLabel: true,
    inputComponent: inputComponent || {
      template: `<div class="alert alert-danger text-center">${section_name}</div>`,
    },
    width: { xs: 48 },
  }
}

export const yhc_estimate_form: ModelDef = {
  tableName: 'yhc_estimate_form',
  tableLabel: 'YHC お見積りフォーム',
  doNotSyncModel: true, // データベース Table を持たない
  overrides: {
    async find(query) {
      return { data: [] } // dummy
    },
  },
  columns: {
    header_1: genSectionColumn('header1', 'YhcEFPageHeader'),
    section_prefs_title: genSectionColumn('お預かり先・お届け先', 'ZipCodeInput'),
    pref_from: {
      type: 'STRING',
      label: 'お預かり先都道府県',
      // selections: () => yhcAreaCodes,
      // customLabel: (value: string) => yhcAreasByCode[value]?.name || '',
      // validate: { notEmpty: true },
      visible: false,
    },
    zip_from: {
      type: 'STRING',
      label: 'お預かり先郵便番号',
      // validate: { notEmpty: true },
      visible: false,
    },
    pref_to: {
      type: 'STRING',
      label: 'お届け先都道府県',
      // selections: () => yhcAreaCodes,
      // customLabel: (value: string) => yhcAreasByCode[value]?.name || '',
      // validate: { notEmpty: true },
      visible: false,
    },
    zip_to: {
      type: 'STRING',
      label: 'お届け先郵便番号',
      // validate: { notEmpty: true },
      visible: false,
    },
    section_items_title: genSectionColumn('家財の選択', 'YhcEFKazaiSectionTitle'),
    section_items: genSectionColumn('section_items', 'YhcEFItemList'),
    section_datetime: genSectionColumn('日時のご確認', 'YhcEFDatetimeInputs'),
    section_furniture_appliance_moving_service_options: genSectionColumn(
      '家具家電移動サービスオプション',
      'YhcEFKaguidoOption',
    ),
    footer: genSectionColumn('footer', 'YhcEFPageFooter'),
    price_display: genSectionColumn('YhcEFTotalPriceDisplay', 'YhcEFTotalPriceDisplay'),
  },
}
